import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';

import { ContainerLayout } from 'data/components';
import { makeStyles } from '@material-ui/styles';

export default function FHEModal(props) {
    const { renderChildren } = props;
    const classes = useStyles(props);
    let history = useHistory();
    let back = e => {
        e.stopPropagation();
        history.goBack();
    };

    return (
        <div className={classes.modal}>
            <ContainerLayout withoutFHEContainer>
                <div className={classes.container}>
                    <IconButton aria-label="close" className={classes.closeIcon} size="small" onClick={back}>
                        <Close fontSize="inherit" />
                    </IconButton>
                    {renderChildren()}
                </div>
            </ContainerLayout>
        </div>
    );
}

FHEModal.propTypes = {
    renderChildren: PropTypes.func.isRequired
};

const useStyles = makeStyles(theme => ({
    modal: {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        zIndex: 10
    },
    container: {
        position: 'relative',
        maxHeight: '100%',
        display: 'flex',
        // borderRadius: 8,
        // backgroundColor: theme.palette.background.paper,
        [theme.breakpoints.down('xs')]: {
            maxHeight: 'none'
        }
    },
    closeIcon: {
        position: 'absolute',
        top: 10,
        right: 10,
        zIndex: 30,
        [theme.breakpoints.down('sm')]: {
            top: 0,
            right: 0
        },
        [theme.breakpoints.down('xs')]: {
            top: 0,
            right: 0
        }
    }
}));



// WEBPACK FOOTER //
// ./data/components/FHEModal.js